import React from 'react';
import { Helmet } from 'react-helmet';

import { FieldBulletinBoardRegisterProvider } from '../services/fieldBulletinBoard/FieldBulletinBoardRegisterContext';

import { FieldBulletinBoardHeaderRegister } from '../components/fieldBulletinBoard/FieldBulletinBoardHeaderRegister';
import { FieldBulletinBoardContentsRegister } from '../components/fieldBulletinBoard/FieldBulletinBoardContentsRegister';
import { FieldBulletinBoardPublishSettingsRegister } from '../components/fieldBulletinBoard/FieldBulletinBoardPublishSettingsRegister';
import { FieldBulletinBoardFooterRegister } from '../components/fieldBulletinBoard/FieldBulletinBoardFooterRegister';

import { HEADER_CONSTANTS } from '../utilities/constants';
import { useViewportSize } from '../utilities/useViewPort';

import Styles from '../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardForm.scss';

/**
 * 現場掲示板新規作成
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardRegister({ view }) {
  const { viewportHeight } = useViewportSize();
  return (
    <FieldBulletinBoardRegisterProvider
      fieldBulletinBoardSearchParam={view.state.fieldBulletinBoardSearchParam}
    >
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {data.title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <div className={`${Styles.main}`} style={{height: `${viewportHeight}px`}}>
            <FieldBulletinBoardHeaderRegister />
            <FieldBulletinBoardContentsRegister />
            <FieldBulletinBoardPublishSettingsRegister />
            <FieldBulletinBoardFooterRegister />
          </div>
        </div>
      </div>
    </FieldBulletinBoardRegisterProvider>
  );
}

const data = {
  title: 'お知らせ新規作成',
};



// WEBPACK FOOTER //
// ./src/pages/FieldBulletinBoardRegister.jsx